import useAuthStore from "@/store/use-auth-store";
import {
  useAuthGateStore,
  type AuthGateOpenOptions,
} from "../store/auth-gate-store";
import { persistAuthGateRedirect } from "../utils/redirect";

/**
 * useRequireAuth
 * Public modda auth gerektiren aksiyonları korumak için kullanılır.
 *
 * Kullanım:
 * const { requireAuth } = useRequireAuth();
 * const handleGenerate = () => {
 *   if (!requireAuth()) return; // Oturum yoksa popup açılır, false döner
 *   // ...auth gerektiren iş
 * };
 */
export const useRequireAuth = () => {
  const { user, refreshToken, isTokenExpired } = useAuthStore();
  const { openAuthGate } = useAuthGateStore();

  // PrivateRoute ile aynı oturum semantiği:
  // token geçerli VEYA refresh token mevcut
  const hasSession = !!(user && (!isTokenExpired() || refreshToken));

  /**
   * Oturum varsa true döner (ve verilmişse action'ı çalıştırır).
   * Oturum yoksa auth gate popup'ını açar ve false döner.
   */
  const requireAuth = (
    action?: () => void,
    options?: AuthGateOpenOptions,
  ): boolean => {
    if (hasSession) {
      action?.();
      return true;
    }

    if (options?.redirectTo) persistAuthGateRedirect(options.redirectTo);
    useAuthGateStore.getState().openAuthGate(options);
    return false;
  };

  return { hasSession, requireAuth, openAuthGate };
};
